/**
 * Equipment type master — catalog used when villagers register assets.
 * Aligns with product Vehicle_Type list + mobile asset registration.
 */

export const EQUIPMENT_CATEGORIES = [
  'Agriculture',
  'Construction',
  'Haulage',
  'Utility',
  'Material handling',
  'Other',
];

export const VEHICLE_CLASSES = ['LMV', 'HMV', 'Construction Equipment'];

export const equipmentMasterSeed = [
  {
    equipmentId: 'EQ-001',
    name: 'Tractor',
    category: 'Agriculture',
    vehicleClass: 'LMV',
    description: 'Agricultural tractor',
    active: true,
  },
  {
    equipmentId: 'EQ-002',
    name: 'Trailer',
    category: 'Agriculture',
    vehicleClass: 'HMV',
    description: 'Tractor trailer / trolley',
    active: true,
  },
  {
    equipmentId: 'EQ-003',
    name: 'Backhoe Loader',
    category: 'Construction',
    vehicleClass: 'Construction Equipment',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-004',
    name: 'Excavator',
    category: 'Construction',
    vehicleClass: 'Construction Equipment',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-005',
    name: 'Dumper',
    category: 'Haulage',
    vehicleClass: 'HMV',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-006',
    name: 'Truck',
    category: 'Haulage',
    vehicleClass: 'HMV',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-007',
    name: 'Water Tanker',
    category: 'Utility',
    vehicleClass: 'HMV',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-008',
    name: 'Crane',
    category: 'Construction',
    vehicleClass: 'Construction Equipment',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-009',
    name: 'Forklift',
    category: 'Material handling',
    vehicleClass: 'LMV',
    description: '',
    active: true,
  },
  {
    equipmentId: 'EQ-010',
    name: 'Road Roller',
    category: 'Construction',
    vehicleClass: 'Construction Equipment',
    description: '',
    active: false,
  },
];
